<template>
  <div class="box">
    <div class="head" >
      <img src="../../assets/img/icon_arrowLeft.png" alt  @click="gotoIndex" />
      <div class="turnIofo">
        <span>分享商品支出金额明细</span>
      </div>
    </div>
    <div class="b_top">
      <div class="date" @click="showTime(0)">{{startDate?startDate:'年-月-日'}}</div>
      <div class="kang"></div>
      <div class="date" @click="showTime(1)">{{endDate?endDate:'年-月-日'}}</div>
      <div class="botn"></div>
      <van-button plain type="info" class="allDate" @click="shareList(0,1)">全部数据</van-button>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="flex:1">
      <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad" >
          <!-- <div style="widht:300px;height:600px"></div> -->
        <div class="expenditure" v-if="amountlist.length" >
          <span class="text">分享佣金合计支出:</span>
          <span class="price">¥{{sumMoney}}</span>
        </div>
        <div class="b-bottom" v-if="amountlist.length">
          <div class="seller" v-for="(item,index) in amountlist" :key="index">
            <div class="image">
              <img v-if="item.orderType==2" src="../../assets/img/icon_coupon_42.png" alt />
              <img v-if="item.orderType==3" src="../../assets/img/icon_hotgoods_42.png" alt />
              <div class="s_right limitonewrap">
                <div class="name limitonewrap">{{item.productName}}</div>
              </div>
            </div>
            <div class="numberId">订单号:{{item.orderSn}}</div>
            <span class="price">￥{{item.shareMoney}}</span>
            <div class="time">{{item.createtime}}</div>
          </div>
        </div>
        <div class="none" v-else>
          <img src="../../assets/img/pic_noOrders.png" alt />
          <span>暂无相关数据</span>
        </div>
      </van-list>
    </van-pull-refresh>

    <van-popup v-model="flag" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @cancel="showTime"
        @confirm="confirmTime"
      />
    </van-popup>
  </div>
</template>

<script>
import { shareList,sumOutMoney } from "@/api/join";
export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1), //下拉框最小选择时间
      maxDate: new Date(), //下拉框最大选择时间
      currentDate: new Date(), //默认选择时间
      flag: false, //是否显示时间选择器
      startDate: "", //开始时间
      endDate: "", //结束时间
      type: 0, //0初试时间 1结束时间
      pageIndex: 1, // 分页页数
      isMore: true, //有无更多
      amountlist: [], //分享支出列表
      loading: false,
      finished: false,
      refreshing: false,
      sumMoney:'',//分享商品合计支出总金额
      token:''
    };
  },
  mounted() {
       let parse = window.location.href
        parse =  parse.split('?')[1]
        parse = parse.split('token=')[1]
        this.token  = parse
      this.sumOutMoney()
  },
  methods: {
      gotoIndex(){   //头部返回键
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goAppBack();
        } else {
          // ios环境
          window.webkit.messageHandlers.goAppBack.postMessage('');
        }
      
    },
    onLoad(value) {
      this.shareList(value,1);
    },
    onRefresh() {  //下拉刷新
      this.pageIndex = 1;
      this.onLoad(1);
    },
    shareList(type,ccc) {
        let obj
      //2.7.0卖家获取 分享商品支出金额明细
      if(ccc){
           obj = {
        page: {
          way: 1, // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "10", //数量
        },
        token:this.token
      }
      }else{
            obj = {
        page: {
          way: 1, // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "10", //数量
        },
        startTime: this.startDate + " 00:00:00", //开始时间
        endTime: this.endDate + " 00:00:00", //结束时间
        token:this.token
      }
      }
      
      shareList(obj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          let list = res.content.list;
          if (list.length < 10) {
            this.finished = true;
          }
          if (this.pageIndex == 1) {
            this.amountlist = res.content.list;
          } else {
            this.amountlist = this.amountlist.concat(res.content.list);
          }
          if (type == 1) {
            setTimeout(() => {
              this.$toast("刷新成功");
              this.refreshing = false;
              this.finished = true;
            }, 1000);
          }
        } else {
          setTimeout(() => {
            this.$toast(res.appStatus.message);
            this.refreshing = false;
            this.finished = true;
          }, 1000);
        }
        this.loading=false
        
      });
    },
    sumOutMoney(){
        sumOutMoney({token:this.token}).then(res=>{
            if (res.appStatus.errorCode == 0) {
                    this.sumMoney = res.content.sumMoney
                }else{
                    this.$toast(res.appStatus.message);
                }
        })
    },
    showTime(type) {
      if (type == 1) {
        if (!parseInt(this.startDate)) {
          console.log(1);

          this.$toast("请选择起始时间");
          return;
        }
      }
      this.flag = !this.flag;
      this.type = type;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    confirmTime() {
      let date =
        this.currentDate.getFullYear() +
        "-" +
        ((this.currentDate.getMonth() + 1)<10?('0'+(this.currentDate.getMonth() + 1)):(this.currentDate.getMonth() + 1)) +
        "-" +
        (this.currentDate.getDate()<10?'0'+this.currentDate.getDate():this.currentDate.getDate());
      this.flag = false;
      this.type ? (this.endDate = date) : (this.startDate = date);
      if (new Date(this.endDate) - new Date(this.startDate) < 0) {
        this.$toast("结束时间不得早于开始时间");
        return;
      }
        if(this.endDate){
            this.pageIndex=1
            this.shareList(0)
        }
      
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/ .van-pull-refresh__track {
//   height: 100%;
// }
// /deep/ .van-list {
//   height: 100%;
// }
/deep/.van-pull-refresh {
  overflow: scroll;
}
.head {
        display: flex;
        align-items: center;
        padding: 7px 0;
        z-index: 10;
        text-align: center;
        background: #144AA7;
        width: 100%;
        color:#fff;
        border-bottom: 1px solid rgba(220, 220, 220, 1);
        img {
            width: 30px;
            height: 30px;
            margin-right: 11px;
        }
        .turnIofo {
            flex: 1;
            font-size: 18px;
            padding-right: 30px;
        }
    }
.box {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  color: #1d1d1d;
  text-align: left;
  display: flex;
  flex-direction: column;
  .b_top {
    padding: 15px;
    display: flex;
    background: #fff;
    align-items: center;
    .date {
      font-size: 14px;
      width: 100px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: #f5f5f5;
    }
    .kang {
      background: #1d1d1d;
      margin: 0 8px;
      width: 11px;
      height: 1px;
    }
    .allDate {
      width: 80px;
      height: 36px;
      color: #187fe6;
      font-size: 15px;
      border: 1px solid rgba(24, 127, 230, 1);
      border-radius: 2px;
      padding: 0;
      line-height: 36px;
    }
    .botn {
      flex: 1;
    }
  }
  .expenditure {
    padding: 17px 15px;
    .text {
      font-size: 15px;
    }
    .price {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .b-bottom {
    flex: 1;
    overflow: auto;
  }
  .seller {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    background: #fff;
    border-radius: 5px;
    margin: 10px 12px;
    padding: 10px;
    .image {
      display: flex;
      img {
        border-radius: 5px;
        width: 19px;
        height: 19px;
        margin-right: 5px;
      }
    }
    .s_right {
      flex: 1;
    }
    .numberId {
      margin: 4px 0 8px;
      color: #999;
    }
    .name {
      font-size: 14px;
    }
    .price {
      font-weight: bold;
      font-size: 15px;
    }
    .time {
      text-align: right;
      color: #999;
      padding-top: 6px;
    }
  }

  .none {
    margin-top: 75px;
    img {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      display: block;
    }
    span {
      font-size: 15px;
      color: #666;
      text-align: center;
      display: block;
    }
  }
}
/deep/ .van-hairline--top-bottom {
  background: #f5f5f5;
}
/deep/ .van-picker__cancel,
.van-picker__confirm {
  font-size: 15px;
}
</style>